import * as ActionType from "./chat.type";

const initialState = {
  conversations: [],
  totalConversations: 0,
  conversationDetails: null,
  messages: [],
  totalMessages: 0,
  stats: null,
};

export const chatReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_CONVERSATIONS:
      return {
        ...state,
        conversations: action.payload.data,
        totalConversations: action.payload.totalConversations,
      };

    case ActionType.GET_CONVERSATION_DETAILS:
      return {
        ...state,
        conversationDetails: action.payload.conversation,
        messages: action.payload.messages,
        totalMessages: action.payload.totalMessages,
      };

    case ActionType.BLOCK_UNBLOCK_CONVERSATION:
      return {
        ...state,
        conversations: state.conversations.map((conv) => {
          if (conv._id === action.payload.id) return action.payload.data;
          else return conv;
        }),
        conversationDetails: state.conversationDetails?._id === action.payload.id
          ? action.payload.data
          : state.conversationDetails,
      };

    case ActionType.DELETE_MESSAGE:
      return {
        ...state,
        messages: state.messages.filter((msg) => msg._id !== action.payload),
        totalMessages: state.totalMessages - 1,
      };

    case ActionType.GET_CHAT_STATS:
      return {
        ...state,
        stats: action.payload,
      };

    case ActionType.CLEAR_CONVERSATION_DETAILS:
      return {
        ...state,
        conversationDetails: null,
        messages: [],
        totalMessages: 0,
      };

    default:
      return state;
  }
};
